<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <SequenceTypeBlock />
            <LayoutContainer>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.searchParameters') }}
                    </SectionTitle>
                    <SectionBlock>
                        <SubjectLengthField />
                        <AlignmentIdentityField />
                        <QueryIdentityField />
                        <QueryCoverageField />
                        <SubjectIdentityField />
                        <SubjectCoverageField />
                    </SectionBlock>
                </LayoutColumn>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <div>
                        <SectionBlock>
                            <MatchWithGapsField />
                            <EvalueField />
                            <LowComplexRegionField />
                        </SectionBlock>
                        <AlgorithmBlock v-if="!store.algorithmSettingsDisabled" />
                    </div>
                </LayoutColumn>
            </LayoutContainer>
        </LayoutPaddingSpace>
        <ResetSection :show-apply-to-all="showApplyToAll" />
    </LayoutWrapper>
</template>

<script>
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';
import AlgorithmBlock from './Algorithm.prefab.vue';
import SequenceTypeBlock from './SequenceType.prefab.vue';

export default {
    components: {
        AlgorithmBlock,
        SequenceTypeBlock,
    },
    extends: BioSearchSettingProvider,
    props: {
        showApplyToAll: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
